import { FC } from 'react'
import { ChooseKyc } from './components'

export const KycVerification: FC = () => {
  return <ChooseKyc />
}
